<template>
    <el-col :span="24">
      <div
        class="ma-0"
        v-loading="loading"
        :element-loading-spinner="svg"
        element-loading-svg-view-box="-10, -10, 50, 50"
        element-loading-background="rgba(122, 122, 122, 0.8)"
      >
      <div class="custom-table-design">
        <el-table
          :data="userDataList"
          :fit="true"
          stripe
          height="650"
          :row-class-name="tableRowClassName"
          @row-click="handleRowClick"
          class="my-2 data-table"
          scrollbar-always-on: false
        >
          <el-table-column type="expand">
            <template #default="props">
              <grouped-site-chargers-table
                :chargers="props.row.central_site?.chargers"
                :included-filter="includedFilterProp"
              />
            </template>
          </el-table-column>
          <el-table-column
            :label="'Motion Site ID'"
            :prop="'group_id'"
            :width="$vuetify.display.width <= 1600 ? 180 : ''"
            sortable
          />
          <el-table-column
            :label="'Customer'"
            :prop="'central_site.full_name'"
            :width="$vuetify.display.width <= 1600 ? 200 : ''"
            sortable
            >
              <template #default="scope">
                {{
                scope.row.central_site.full_name == null
                    ? ""
                    : (scope.row.central_site.full_name).replaceAll("_", " ")
                }}
              </template>
          </el-table-column>
          <el-table-column
            :label="'Site Name'"
            :prop="'central_site.site_name'"
            :width="$vuetify.display.width <= 1600 ? 200 : ''"
            sortable
          />
          <el-table-column
            :label="'Postcode'"
            :prop="'central_site.postcode'"
            :width="$vuetify.display.width <= 1600 ? 140 : ''"
            sortable
          />
          <el-table-column
              :label="'State'"
              :prop="'central_site.state'"
              :width="$vuetify.display.width <= 1600 ? 200 : ''"
              sortable
            >
              <template #default="scope">
                {{
                scope.row.central_site.state == null
                    ? ""
                    : (scope.row.central_site.state).toUpperCase().replaceAll("_", " ")
                }}
              </template>
            </el-table-column>
          <el-table-column
              :label="'Elec Region'"
              :prop="'central_site.elec_region'"
              :width="$vuetify.display.width <= 1600 ? 200 : ''"
              sortable
            >
              <template #default="scope">
                {{
                scope.row.central_site.elec_region == null
                    ? ""
                    : (scope.row.central_site.elec_region).toUpperCase().replaceAll("_", " ")
                }}
              </template>
            </el-table-column>
          <el-table-column
            :label="'Address'"
            :prop="'central_site.address_comment'"
            :width="$vuetify.display.width <= 1600 ? 180 : ''"
            sortable
          />
          <el-table-column
            :label="'Group Size'"
            :prop="'total_sites_in_group'"
            :width="$vuetify.display.width <= 1600 ? 160 : ''"
            sortable
          />
          <el-table-column
            v-if="$vuetify.display.width < 500"
            :label="'Operations'"
            :prop="'operations'"
            align="center"
            width="250"
          >
            <template #default="scope">
                <el-tooltip placement="top" effect="light">
                  <template #content>Find in map</template>
                  <el-button
                    @click.stop="handleFindInMap(scope.$index, scope.row)"
                    size="small"
                    class="height-25 rounded-2 m-0 ml-2"
                    color="#DDF0AC"
                    style="width: 25px; height: 25px; padding: 0px; align-items: center;"
                  >
                      <svg style="width: 24px; height: 24px;">
                          <use href="@/assets/svg/newSvgIcon.svg#find-in-map-btn"></use>
                      </svg>
                  </el-button>
                </el-tooltip>  
            </template>
          </el-table-column>
          <el-table-column
            v-else
            fixed="right"
            :label="'Operations'"
            :prop="'operations'"
            align="center"
            width="250"
          >
            <template #default="scope">
              <el-tooltip placement="top" effect="light">
                <template #content>View duplicate sites</template>
                <el-button
                  @click.stop="handleViewNearbySites(scope.row)"
                  size="small"
                  class="height-25 rounded-2 m-0 ml-2"
                  color="#DDF0AC"
                  style="width: 25px; height: 25px; padding: 0px; align-items: center;"
                >
                    <svg style="width: 24px; height: 24px;">
                        <use href="@/assets/svg/newSvgIcon.svg#tableOperationMoreInfo"></use>
                    </svg>
                </el-button>
              </el-tooltip>
              <el-tooltip placement="top" effect="light">
                <template #content>Find in map</template>
                <el-button
                  @click.stop="handleFindInMap(scope.$index, scope.row.central_site.lat, scope.row.central_site.lng)"
                  size="small"
                  class="height-25 rounded-2 m-0 ml-2"
                  color="#DDF0AC"
                  style="width: 25px; height: 25px; padding: 0px; align-items: center;"
                >
                    <svg style="width: 24px; height: 24px;">
                        <use href="@/assets/svg/newSvgIcon.svg#find-in-map-btn"></use>
                    </svg>
                </el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- Nearby Sites Popup Dialog -->
      <el-dialog
        v-model="showNearbySitesDialog"
        class="public-style"
        :title="`Motion Site ID - ${selectedGroupInfo?.group_id || 'Group'}`"
        :width="$vuetify.display.width <= 1400 ? 800 : $vuetify.display.width <= 1600 ? 1000 : $vuetify.display.width <= 2000 ? 1400 : $vuetify.display.width <= 2456 ? '75%' : ''"
        :fullscreen="$vuetify.display.width <= 800 ? true : false"
        :height="$vuetify.display.width <= 630 ? '550px' : '650px'"
        :close-on-click-modal="false"
        :close-on-press-escape="true"
      >
        <div class="popUpTable" v-if="selectedGroupInfo && selectedGroupInfo.nearby_sites">
          <div class="custom-table-design">
          <p class="moderat-white">
            Central Site Name : {{ selectedGroupInfo.central_site.site_name }}
          </p>
          <p class="moderat-white ml-20">
            Customer : {{ selectedGroupInfo.central_site.full_name }}
          </p>
          <p class="moderat-white ml-20">
            Postcode : {{ selectedGroupInfo.central_site.postcode }}
          </p>
          <p class="moderat-white ml-20">
            Address : {{ selectedGroupInfo.central_site.address_comment }}
          </p>
          <p class="moderat-white ml-20">
            Lat : {{ selectedGroupInfo.central_site.lat }} - Lng : {{ selectedGroupInfo.central_site.lng }}
          </p>
          <el-table
            :data="selectedGroupInfo.nearby_sites"
            :fit="true"
            stripe
            height="400"
            class="my-2 data-table"
            scrollbar-always-on: false
          >
            <el-table-column type="expand">
              <template #default="props">
                <grouped-site-chargers-table
                  :chargers="props.row.chargers"
                  :included-filter="includedFilterProp"
                />
              </template>
            </el-table-column>
            <el-table-column
              :label="'Customer'"
              :prop="'full_name'"
              :width="$vuetify.display.width <= 1600 ? 200 : ''"
              sortable
            />
            <el-table-column
              :label="'Site Name'"
              :prop="'site_name'"
              :width="$vuetify.display.width <= 1600 ? 200 : ''"
              sortable
            />
            <el-table-column
              :label="'Postcode'"
              :prop="'postcode'"
              :width="$vuetify.display.width <= 1600 ? 140 : ''"
              sortable
            />
            <el-table-column
              :label="'State'"
              :prop="'central_site.state'"
              :width="$vuetify.display.width <= 1600 ? 200 : ''"
              sortable
            >
              <template #default="scope">
                {{
                scope.row.state == null
                    ? ""
                    : (scope.row.state).toUpperCase().replaceAll("_", " ")
                }}
              </template>
            </el-table-column>
            <el-table-column
              :label="'Elec Region'"
              :prop="'central_site.elec_region'"
              :width="$vuetify.display.width <= 1600 ? 200 : ''"
              sortable
            >
              <template #default="scope">
                {{
                scope.row.elec_region == null
                    ? ""
                    : (scope.row.elec_region).toUpperCase().replaceAll("_", " ")
                }}
              </template>
            </el-table-column>
            <el-table-column
              :label="'Address'"
              :prop="'address_comment'"
              :width="$vuetify.display.width <= 1600 ? 200 : ''"
              sortable
            />
            <el-table-column
              :label="'Distance'"
              :prop="'distance_m'"
              :width="$vuetify.display.width <= 1600 ? 150 : ''"
              sortable
            />
            <el-table-column
              :label="'Latitude'"
              :prop="'lat'"
              :width="$vuetify.display.width <= 1600 ? 150 : ''"
              sortable
            />
            <el-table-column
              :label="'Longitude'"
              :prop="'lng'"
              :width="$vuetify.display.width <= 1600 ? 150 : ''"
              sortable
            />
          </el-table>
          </div>
        </div>        
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="showNearbySitesDialog = false">Close</el-button>
          </span>
        </template>
      </el-dialog>
  
      <!-- <div class="custom-pagination" v-if="$vuetify.display.width >= 700">
        <el-row class="row-bg" justify="space-between">
          <el-col
            :span="5"
            class="d-flex justify-content-start align-items-center"
          >
            <el-select
              v-model="perPageCount"
              placeholder="Select"
              size="small"
              style="width: 70px"
            >
  
                <el-option label="10" :value="'10'" />
                <el-option label="25" :value="'25'" />
                <el-option label="50" :value="'50'" />
                <el-option label="100" :value="'100'" />
                <el-option label="500" :value="'500'" />
                <el-option label="1k" :value="'1000'" />
            </el-select>
          </el-col>
          <el-col
            :span="8"
            class="d-flex align-items-center justify-content-center"
          >
            <el-pagination
              small
              background
              layout="prev, pager, next"
              :total="total_items"
              v-model:page-size="page_size"
              v-model:current-page="current_page"
              @current-change="changePage"
              class="my-4"
            />
          </el-col>
          <el-col :span="5" class="d-flex justify-content-end align-items-center">
            <span class="text-white">
              {{ ((current_page - 1) * perPageCount + 1).toLocaleString() }}-{{
                current_page * perPageCount > total_items
                  ? total_items.toLocaleString()
                  : (current_page * perPageCount).toLocaleString()
              }}
              of {{ total_items.toLocaleString() }}
            </span>
          </el-col>
        </el-row>
      </div>
  
      <div class="custom-pagination" v-if="$vuetify.display.width < 700">
        <el-row class="row-bg" justify="space-between">
          <el-col
            :span="24"
            class="d-flex align-items-center justify-content-center"
          >
            <el-pagination
              small
              background
              layout="prev, pager, next"
              :total="total_items"
              v-model:page-size="page_size"
              v-model:current-page="current_page"
              @current-change="changePage"
              class="my-4"
            />
          </el-col>
          <el-col
            :span="10"
            class="d-flex justify-content-end align-items-center"
          >
            <el-select
              v-model="perPageCount"
              placeholder="Select"
              size="small"
              style="width: 70px"
            >
                <el-option label="10" :value="'10'" />
                <el-option label="25" :value="'25'" />
                <el-option label="50" :value="'50'" />
                <el-option label="100" :value="'100'" />
                <el-option label="500" :value="'500'" />
                <el-option label="1k" :value="'1000'" />
            </el-select>
          </el-col>
          <el-col :span="10" class="d-flex justify-content-start align-items-center">
            <span class="text-white">
              {{ ((current_page - 1) * perPageCount + 1).toLocaleString() }}-{{
                current_page * perPageCount > total_items
                  ? total_items.toLocaleString()
                  : (current_page * perPageCount).toLocaleString()
              }}
              of {{ total_items.toLocaleString() }}
            </span>
          </el-col>
        </el-row>
      </div> -->
      </div>
    </el-col>
</template>

<script>
import GroupedSiteChargersTable from "./GroupedSiteChargersTable.vue";
// import { ElMessageBox } from "element-plus";
// import ShowDetail from "./dialogDetail.vue";
// import UserService from "../../services/user.service";
export default {
  props: {
    loadingProp: {
      type: Boolean,
      default: false,
    },
    usersDataProp: {
      type: Array,
      default(rawProps) {
        return rawProps;
      },
    },
    totalRowProp: {
      type: Number,
    },
    includedFilterProp: {
      type: String,
      default: "all",
    },
  },
  components: {
    GroupedSiteChargersTable,
    // ShowDetail,
  },
  data() {
    return {
      show: true,
      userDataList: [],
      search: "",
      current_page: 1,
      page_size: 50,
      total_items: 100,
      perPageCount: 50,
      loading: false,
      show_modal: false,
      data_modal: null,
      current_row_index: null,
      showNearbySitesDialog: false,
      selectedGroupInfo: null,
    };
  },
  watch: {
    loadingProp: {
      handler: function (newValue) {
        this.loading = newValue;
      },
      deep: true,
    },
    usersDataProp: {
      handler: function (newValue) {
        this.userDataList = newValue;
      },
      deep: true,
    },
    totalRowProp: {
      handler: function (newValue) {
        this.total_items = newValue;
        console.log(this.total_items);
      },
      deep: true,
    },
    perPageCount: function (newVal) {
      this.current_page = 1;
      this.page_size = parseInt(newVal);
      this.$emit("tableAction", {
        index: this.page_size,
        data: null,
        kind: "perPageChange",
      });
    },
  },
  methods: {
    handleFindInMap(index, lat, lng) {
      console.log('index', index);
      console.log('lat', lat);
      console.log('lng', lng);
      this.$emit("tableAction", {
        index: index,
        data: {
          lat: lat,
          lng: lng,
        },
        kind: "findInMap",
      });
    },
    handleViewNearbySites(row) {
      this.selectedGroupInfo = row;
      this.showNearbySitesDialog = true;
    },
    handleRowClick(row, column, event) {
      console.log(row, column, event);
    },
    handleUpdate(index, data) {
      this.$emit("tableAction", { index: index, data: data, kind: "edit" });
    },
    handleDelete(index, event) {
      this.$emit("tableAction", { index: index, data: event, kind: "delete" });
    },
    changePage(page) {
      this.$emit("tableAction", {
        index: page,
        data: null,
        kind: "changePage",
      });
    },
  },
};
</script>